import {
  Document as RichTextDocument,
  Text,
  TopLevelBlock,
} from '@contentful/rich-text-types';

import Link from '@/components/Link/Link';
import { IndexedTopLevelBlock } from '@/components/RichText/RichText';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './BlogTableOfContents.styles';

interface BlogTableOfContentsContent {
  body: RichTextDocument;
}

export default function BlogTableOfContents({
  body,
}: BlogTableOfContentsContent): React.JSX.Element {
  const { classes, cx } = useStyles();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });

  const { content } = body;

  const headings = content
    .map((block: TopLevelBlock, i: number) => ({ ...block, index: i }))
    .filter(
      (block: IndexedTopLevelBlock) =>
        block.nodeType === 'heading-2' || block.nodeType === 'heading-3'
    );

  return (
    <div className={classes.blogTableOfContents}>
      <h5 className={cx(classes.contentsHeader, globalClasses.h5)}>
        Table of contents
      </h5>
      {headings.map((block: IndexedTopLevelBlock) => {
        const text = (block.content[0] as Text).value;
        return (
          <Link
            href={`#${text.replace(/\W/g, '_')}_${block.index}`}
            key={text}
            className={globalClasses.h5}
            title={text}
          >
            {text}
          </Link>
        );
      })}
    </div>
  );
}
